export function cleanFileName(filename: string) {
  return filename.toLowerCase().replace(/\s*/, '')
}

export function ensureAbsoluteURL(path: string, base: string) {
  if (!path.startsWith('http')) {
    return new URL(path, base).toString()
  }
  return path
}
